<template>
  <div>
    <!-- 筛选 -->
    <el-card shadow='never'>
      <el-button size="mini"
                 type="primary">生成需求单链接</el-button>
      <!-- 数据统计 -->

    </el-card>
    <!-- 列表 -->
    <el-card shadow='never'>
      <el-table :data="requirement_data"
                v-loading="loading"
                style="width: 100%">

        <el-table-column prop="status_name"
                         label="行程状态"
                         width="160">
          <template slot-scope="status_name">
            <!-- 状态 -->
            <div style="background-color:yellow"></div>
            <!-- 下拉 -->
            <el-dropdown szie="mini"
                         placement="bottom-start"
                         @visible-change="tripStatusChange(status_name.row)"
                         @command="handleCommand"
                         trigger="click">
              <span class="el-dropdown-link">
                <span class="status_style_0"
                      v-if="status_name.row.status == 0">
                  {{status_name.row.status_name}}</span>
                <span class="status_style_1"
                      v-if="status_name.row.status == 1">{{status_name.row.status_name}}</span>
                <span class="status_style_2"
                      v-if="status_name.row.status == 2">{{status_name.row.status_name}}</span>
                <span class="status_style_3"
                      v-if="status_name.row.status == 3">{{status_name.row.status_name}}</span>
                <span class="status_style_4"
                      v-if="status_name.row.status == 4">{{status_name.row.status_name}}</span>
                <span class="status_style_5"
                      v-if="status_name.row.status == 5">{{status_name.row.status_name}}</span>
                <span class="status_style_6"
                      v-if="status_name.row.status == 6">{{status_name.row.status_name}}</span>
                <span class="status_style_7"
                      v-if="status_name.row.status == 7">{{status_name.row.status_name}}</span>
                <span class="status_style_8"
                      v-if="status_name.row.status == 8">{{status_name.row.status_name}}</span>

                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command='0'>
                  <i style="color:crimson"
                     class="el-icon-info"></i>
                  {{status_list[0]}}
                </el-dropdown-item>
                <el-dropdown-item command='1'>
                  <i style="color:green"
                     class="el-icon-info"></i>
                  {{status_list[1]}}
                </el-dropdown-item>
                <el-dropdown-item command='2'>
                  <i style="color:rgb(220, 150, 20)"
                     class="el-icon-info"></i>
                  {{status_list[2]}}
                </el-dropdown-item>
                <el-dropdown-item command='3'>
                  <i style="color:red"
                     class="el-icon-info"></i>
                  {{status_list[3]}}
                </el-dropdown-item>
                <el-dropdown-item command='4'
                                  divided>
                  <i style="color:rgb(255, 110, 139)"
                     class="el-icon-info"></i>
                  {{status_list[4]}}
                </el-dropdown-item>
                <el-dropdown-item command='5'>
                  <i style="color:rgb(20, 147, 220)"
                     class="el-icon-info"></i>
                  {{status_list[5]}}
                </el-dropdown-item>
                <el-dropdown-item command='6'>
                  <i style="color: rgb(167, 220, 20)"
                     class="el-icon-info"></i>
                  {{status_list[6]}}
                </el-dropdown-item>
                <el-dropdown-item command='7'
                                  divided>
                  <i style="color:rgb(133, 141, 255)"
                     class="el-icon-info"></i>
                  {{status_list[7]}}
                </el-dropdown-item>
                <el-dropdown-item command='8'>
                  <i style="color:rgb(160, 160, 160)"
                     class="el-icon-info"></i>
                  {{status_list[8]}}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <el-table-column prop="id"
                         label="编号"
                         align="center"
                         width="50">
        </el-table-column>
        <!-- <el-table-column prop="dest_name"
                         label="城市"
                         width="60">
          <template slot-scope="dest_name">

          </template>
        </el-table-column> -->
        <el-table-column label="联系人姓名"
                         width="90">
          <template slot-scope="scope">
            <p style="font-weight:900">{{ scope.row.contact }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="start_date"
                         label="出发日期"
                         width="100">
          <!-- 类型 -->
          <!-- 内容 -->
        </el-table-column>
        <el-table-column prop="requirement_text"
                         label="目的地(点击查看需求概况)">
          <template slot-scope="scope">

            <!-- 需求文字 -->
            <el-popover trigger="click"
                        placement="top">
              <p>{{scope.row.requirement_text}}</p>
              <div slot="reference"
                   style="font-size:10px">
                <!-- 目的地 -->
                <span style="font-size:10px; background-color:lightgrey;padding:5px">
                  城市：
                  <span v-for="dest,index in scope.row.dest_name"
                        :key="index">{{dest}} <span v-if="index !== scope.row.dest_name.length-1">,</span> </span>
                </span>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="来源"
                         align="center"
                         width="90">
          <template slot-scope="scope">
            <div style="font: 0.5em sans-serif; border:1px solid #ff5421;font-weight:900;border-radius:10px">
              {{scope.row.source_name}}
            </div>
          </template>
        </el-table-column>
        <!-- --------------------操作---------------------- -->
        <el-table-column align="center"
                         label="操作">
          <template slot-scope="op">
            <el-button-group>
              <el-button size="mini"
                         v-if="op.row.status == 0"
                         @click="editorTravelPlanForRequire(op.row)"
                         icon="el-icon-plus">新建方案
              </el-button>
              <el-button size="mini"
                         v-else
                         type="primary"
                         @click="showTravelPlanForRequire(op.row)"
                         icon="el-icon-edit">选择方案
              </el-button>
              <!-- 查看需求单详细内容 -->
              <el-button size="mini"
                         type="primary"
                         @click="checkRequireTravelPlan(op.row)"
                         icon="el-icon-document"></el-button>
            </el-button-group>
          </template>
        </el-table-column>
        <el-table-column label="开启行程"
                         width="90">
          <template slot-scope="op">
            <!-- 方案确定状态 -->
            <el-tooltip class="item"
                        effect="dark"
                        placement="top">
              <div slot="content">
                <span v-if="op.row.is_open == ''">未开启</span>
                <span v-else>开启行程</span>
              </div>

              <el-switch v-model="op.row.is_open"
                         @change="openTravel(op.row)"
                         :active-value='true'
                         :inactive-value='false'
                         active-color="#13ce66"
                         inactive-color="#ff4949">
              </el-switch>

            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <!-- ----------------- 分页 ------------------ -->
      <div class="pagination">
        <el-pagination @current-change="handleCurrentChange_system"
                       :small="true"
                       background
                       layout="prev, pager, next,total"
                       :current-page.sync="pagenum_system"
                       :page-size="pagesize"
                       :total="page_account"></el-pagination>
      </div>
    </el-card>
    <!-- -------------------------选择方案对话框------------------------- -->
    <el-dialog :visible.sync="dialogVisibleTravelPlan"
               width="50%">
      <div slot="title">单选框中选择当前使用的方案
        <el-button size="mini"
                   type="primary"
                   style="float:right;margin-right:30px"
                   @click="addNewPlan">添加方案</el-button>
      </div>

      <el-table :data="oneRequirPlanData"
                v-loading="loadingPlan">

        <el-table-column fixed="left"
                         label="方案名称"
                         width="250">
          <template slot-scope="scope">
            <el-radio :label="scope.row.id"
                      @change="selectTravelPlan(scope.row.id)"
                      v-model="selectRadio">{{scope.row.plan_name}}</el-radio>
          </template>

        </el-table-column>

        <el-table-column property="start_date"
                         label="开始日期"
                         width="100"></el-table-column>
        <!-- 行程概况 -->
        <el-table-column property="address"
                         :show-overflow-tooltip="true"
                         label="行程码">
          <template slot-scope="detial">
            {{detial.row.code}}
            <div v-for="item,index of detial.row.plan_detail"
                 :key='index'>
              <!-- 离开概览 -->
              <div v-if="item.departureTrip.dayTripTraverList.length!==0">
                <span>
                  <span>离开 </span>
                  <span>{{item.departureTrip.dayTripInfo.dest}}:</span>
                </span>
                <!-- 概览明细 -->
                <span v-for="item,index of  item.departureTrip.dayTripTraverList"
                      :key="index">
                  <span v-if="'traver_title' in item"> {{item.traver_title}}/</span>
                  <span v-else> 酒店：{{item.residence_name}}/</span>
                </span>
              </div>
              <!-- 中转概览 -->
              <div v-if="item.transitTrip.dayTripTraverList.length!==0">
                <span>
                  <span>中转 </span>
                  <span>{{item.transitTrip.dayTripInfo.dest}}:</span>
                </span>
                <!-- 概览明细 -->
                <span v-for="item,index of  item.transitTrip.dayTripTraverList"
                      :key="index">
                  <span v-if="'traver_title' in item"> {{item.traver_title}}/</span>
                  <span v-else> 酒店：{{item.residence_name}}/</span>
                </span>
              </div>
              <!-- 抵达概览 -->
              <div v-if="item.arrivalTrip.dayTripTraverList.length!==0">
                <span>
                  <span>抵达 </span>
                  <span> {{item.arrivalTrip.dayTripInfo.dest}}:</span>
                </span>
                <!-- 概览明细 -->
                <span v-for="item,index of  item.arrivalTrip.dayTripTraverList"
                      :key="index">
                  <span v-if="'traver_title' in item">{{item.traver_title}}/</span>
                  <span v-else> 酒店：{{item.residence_name}}/</span>
                </span>
              </div>
              <!-- 整日概览 -->
              <div v-if="item.allDayTrip.dayTripTraverList.length!==0">
                <span>
                  <span>整日 </span>
                  <span>{{item.allDayTrip.dayTripInfo.dest}}:</span>
                </span>
                <!-- 概览明细 -->
                <span v-for="item,index of  item.allDayTrip.dayTripTraverList"
                      :key="index">
                  <span v-if="'traver_title' in item"> {{item.traver_title}}/</span>
                  <span v-else> 酒店：{{item.residence_name}}/</span>
                </span>
              </div>
              <!--  -->
            </div>
          </template>
        </el-table-column>
        <el-table-column property="address"
                         width="50"
                         label="编辑">
          <template slot-scope="op">
            <el-button-group>
              <el-link size="mini"
                       type="primary"
                       @click="editorDialogTravelPlan(op.row)"
                       icon="el-icon-edit"></el-link>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- -------------------------查看需求单信息------------------------- -->
    <el-dialog :title="'需求单' +'【'+ `${require_form.id}`+'】'"
               @close="requireDetialVisibleClose()"
               :visible.sync="requireDetialVisible">
      <div>
        <!-- 来源 -->
        <div style="display:flex">
          <div class="mb10">
            <span class="ftw900">来源：</span>

            <el-dropdown size="mini"
                         @command="changeRequireSource">
              <span class="el-dropdown-link">
                {{require_form.source_name}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command='1'>微信</el-dropdown-item>
                <el-dropdown-item command='2'>小红书</el-dropdown-item>
                <el-dropdown-item command='3'>飞猪</el-dropdown-item>
                <el-dropdown-item command='0'>其他</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <!-- 旅行核对清单 -->
          <div class="mb10"
               style="margin-left:20px">
            <span class="ftw900">行李清单：</span>
            <el-link type="primary"
                     @click="openCheckList">
              <span v-if="require_form.check_list_name">{{require_form.check_list_name}}</span>
              <span>未绑定</span>
            </el-link>
          </div>

          <!-- 行前手册 -->
          <div class="mb10"
               style="margin-left:20px">
            <span class="ftw900">行前手册：</span>
            <el-link type="primary"
                     @click="openBeforeTripList">
              <span v-if="require_form.before_trip_title">{{require_form.before_trip_title}}</span>
              <span>未绑定</span>
            </el-link>
          </div>
        </div>
        <el-divider></el-divider>
        <!--  -->
        <div class="mb10">
          <span class="ftw900">目的地：</span>
          <span v-for="dest,index in require_form.dest_name"
                :key="index">{{dest}} <span v-if="index !== require_form.dest_name.length-1">,</span> </span>
        </div>
        <span class="ftw900"> </span>
        <div>
          <!-- 修改 -->
          <span style="float:right;cursor: pointer;color: #ff5421;">
            <i @click="openRenewTripDate()"
               class="el-icon-refresh"></i>
          </span>
          <div v-if="require_form.trip_date_type==1">
            <div>确定了出发日期，还没定机票/车票:
              <p> 出发：{{require_form.start_date}}</p>
              <p> 返回：{{require_form.end_date}}</p>
            </div>
          </div>
          <div v-else-if="require_form.trip_date_type==2">
            <div>
              <div> 已经订好机票/车票:</div>
              <el-image style="width: 100px; height: 100px"
                        :src=" trafficBcooking[0]"
                        :preview-src-list=" trafficBcooking">
              </el-image>
              <p> 出发：{{require_form.start_date}}</p>
              <p> 返回：{{require_form.end_date}}</p>
            </div>
          </div>
          <div v-else-if="require_form.trip_date_type==3">
            还未确定具体出发日期,<span> 大概日期：{{require_form.about_date}}</span>
          </div>
          <div v-else>未选择</div>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <div class="mb10">
          <span class="ftw900">用户ID：</span>
          {{require_form.user_id}}
        </div>
        <div class="mb10">
          <span class="ftw900">联系人：</span>
          {{require_form.contact}}
        </div>
        <div class="mb10">
          <span class="ftw900">联系电话：</span>
          {{require_form.mobile}}
        </div>
        <div class="mb10">
          <span class="ftw900">微信：</span>
          {{require_form.wechat}}
        </div>
        <div class="mb10">
          <span class="ftw900"> 人群：</span>
          <div v-if="require_form.trip_people_type==0">
            与他/她来一场二人之旅
          </div>
          <div v-else-if="require_form.trip_people_type==1">带家人来场旅行（有老人或儿童必选）</div>
          <div v-else-if="require_form.trip_people_type==2">和朋友一起出来玩</div>
          <div v-else-if="require_form.trip_people_type==3">团队一行人出来嗨皮</div>
          <div v-else-if="require_form.trip_people_type==4">独自来一场旅行</div>
          <!--  -->
          <div class="mt10">
            <p> <span class="ftw900">总人数：</span> {{require_form.num_all}}</p>
            <p v-if="require_form.child_num!=0"><span class="ftw900">其中儿童：</span>{{require_form.child_num}}人 ，包括： {{require_form.child_info}}</p>
            <p v-if="require_form.elder_num!=0"><span class="ftw900">其中老人：</span>{{require_form.elder_num}}人 ，包括： {{require_form.elder_info}}</p>

          </div>
        </div>
        <el-divider></el-divider>
        <div class="mb20">
          <!-- 需求编辑器 -->
          <div class="backColorLightYellow pd10">

            <editor-content title="需求与进度状态："
                            :attribuite="require_form.id"
                            @save="saveRequirementButton"
                            :show_content="require_form.requirement_text"></editor-content>
          </div>
        </div>
        <div v-if="requireImageList.length !=0">
          <div class="ftw900"> 旅行要求素材：</div>
          <div class="mt10 ml10">
            <el-image style="width: 100px; height: 100px;"
                      :src="requireImageList[0]"
                      :preview-src-list="requireImageList">
            </el-image>
          </div>
        </div>

        <div class="mt10">
          <span class="ftw900"> 可接受的旅行模式：</span>
          <div class="ml10">
            <div v-if="require_form.travel_mode_explore">✅ 可以探索旅行</div>
            <div v-if="require_form.travel_mode_driving">✅ 可以包车/自驾</div>
            <div v-if="require_form.travel_mode_tour">✅ 可以参加拼团</div>
          </div>
        </div>
        <el-divider></el-divider>
        <div class="ftw900">关于酒店/住处：</div>
        <div v-if="require_form.residence_recommend_type==1">已预定酒店
          <el-image style="width: 100px; height: 100px"
                    :src=" residenceBooking[0]"
                    :preview-src-list=" residenceBooking">
          </el-image>
        </div>

        <div v-else-if="require_form.residence_recommend_type==2">不需要推荐</div>
        <div v-else-if="require_form.residence_recommend_type==3">需要推荐住处，预算为：{{require_form.residence_coat_one_night}}</div>
        <el-divider></el-divider>
        <div>玩乐预算：{{require_form.coast}}</div>
        <el-divider></el-divider>

      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button size="mini"
                   @click="outerVisible = false">关 闭</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="innerVisible = true">删 除</el-button>
      </div>
    </el-dialog>
    <!-- 旅行核对清单 -->
    <el-dialog title="选择清单"
               :visible.sync="visableCheckList">
      <el-table :data="checkListData"
                v-loading="loadingPlan">

        <el-table-column fixed="left"
                         label="清单名称"
                         width="250">
          <template slot-scope="scope">
            <el-radio :label="scope.row.id"
                      @change="selectCheckList(scope.row)"
                      v-model="selectRadio">{{scope.row.list_name}}</el-radio>
          </template>

        </el-table-column>

        <el-table-column property="list_remark"
                         label="清单说明"></el-table-column>
      </el-table>
    </el-dialog>
    <!-- 行前手册 -->
    <el-dialog title="行前手册"
               :visible.sync="visableBeforeTripList">
      <el-table :data="beforeTripList"
                v-loading="loadingPlan">

        <el-table-column fixed="left"
                         label="名称"
                         width="250">
          <template slot-scope="scope">
            <el-radio :label="scope.row.id"
                      @change="selectBeforeTripList(scope.row)"
                      v-model="selectRadio">{{scope.row.before_trip_title}}</el-radio>
          </template>

        </el-table-column>

        <el-table-column property="before_trip_info"
                         label="说明"></el-table-column>
      </el-table>
    </el-dialog>
    <!-- 修改日期 -->
    <el-dialog title="修改旅行日期"
               :visible.sync="visableRenewTripDate">
      <el-form label-position="left"
               label-width="80px"
               :model="require_form">
        <el-form-item label="日期类型">
          <el-radio-group v-model="require_form.trip_date_type">
            <el-radio :label="1">确定了出发日期，还没定机票/车票</el-radio>
            <el-radio :label="2">已经订好机票/车票:</el-radio>
            <el-radio :label="3">还未确定具体出发日期</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="开始日期">
          <el-input size="mini"
                    style="width:30%"
                    v-model="require_form.start_date"></el-input>
        </el-form-item>
        <el-form-item label="结束日期">
          <el-input size="mini"
                    style="width:30%"
                    v-model="require_form.end_date"></el-input>
        </el-form-item>
      </el-form>
      <el-button size="mini"
                 type="primary"
                 @click="renewRequireForm()">更新</el-button>
    </el-dialog>
  </div>
</template>

<script>
import { createLogger } from 'vuex'
import EditorModify from '../../components/common/modify/EditorModify'

export default {
  name: 'requirement-list',
  components: {
    'editor-content': EditorModify,
  },
  data() {
    return {
      loading: false,
      loadingPlan: false,
      contact: '',
      mobile: '',
      source: '',
      status: '',
      start_date: '',
      dest: '',
      requirement_data: [],
      // 当前 需要修改状态的需求单id ，打开下拉菜单时传入
      requireModifuId: null,
      status_list: [
        '新需求',
        '已出方案I请联系',
        '客人确定方案中',
        '方案待修改',
        '等待出发',
        '行程进行中',
        '行程已结束',
        '未确定出发日期',
        '无回复',
      ],
      dialogVisibleTravelPlan: false,
      oneRequirPlanData: [],
      // 打开添加方案的对话框时传入，需求id，添加方案是用来执行。
      addTravelPlanRequireId: null,
      // 选择分享的方案
      selectRadio: null,
      // 需求单明细
      requireDetialVisible: false,
      require_form: {},
      requireImageList: [],
      trafficBcooking: [],
      residenceBooking: [],
      // 分页
      pagesize: 20,
      pagenum_system: 1,
      page_account: null,
      // 需求单
      visableCheckList: false,
      visableBeforeTripList: false,
      visableRenewTripDate: false,
      checkListData: [],
      beforeTripList: [],
    }
  },
  watch: {
    require_form(newVal) {
      this.require_form = newVal
    },
  },
  mounted() {
    this.getRequirementList()
  },
  methods: {
    // 清单对话框
    openCheckList() {
      this.visableCheckList = true
      this.selectRadio = this.require_form.check_list_id
      this.$http.get(`/traver/get_check_list`).then((res) => {
        if (res.data.errno == '0') {
          this.checkListData = res.data.data
        } else {
          this.$message({
            type: 'error',
            message: res.data.errmsg,
          })
        }
      })
    },
    // 行前手册对话框
    openBeforeTripList() {
      this.visableBeforeTripList = true
      this.selectRadio = this.require_form.before_trip
      this.$http.get(`/traver/get_before_trip_list`).then((res) => {
        if (res.data.errno == '0') {
          console.log(res)
          this.beforeTripList = res.data.data
        } else {
          this.$message({
            type: 'error',
            message: res.data.errmsg,
          })
        }
      })
    },
    // 选中核对清单
    selectCheckList(row) {
      // 将 id 和 内容 添加到需求单
      this.$http
        .get(
          `/traver/band_check_list?check_list_id=${row.id}&require_id=${this.require_form.id}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
            this.$message({
              type: 'success',
              message: res.data.errmsg,
            })
          } else {
            this.$message({
              type: 'error',
              message: res.data.errmsg,
            })
          }
        })
    },
    // 选中行前手册
    selectBeforeTripList(row) {
      // 将 id 和 内容 添加到需求单
      this.$http
        .get(
          `/traver/band_before_trip_list?before_trip_id=${row.id}&require_id=${this.require_form.id}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
            this.$message({
              type: 'success',
              message: res.data.errmsg,
            })
          } else {
            this.$message({
              type: 'error',
              message: res.data.errmsg,
            })
          }
        })
    },
    handleCurrentChange_system(page) {
      this.TripPlanList = []
      this.pagenum_system = page
      this.getRequirementList()
    },
    // 开启旅行
    openTravel(item) {
      if (item.current_trip_plan_id == null) {
        this.$message({
          message: '请先选方案',
          type: 'error',
        })
        item.is_open = false
      } else {
        let open_value = 0
        console.log(item.is_open)
        if (item.is_open == true) {
          open_value = 1
        } else {
          open_value = 0
        }
        this.$http
          .get(
            `/traver/change_requirement_is_open?requirement_id=${item.id}&is_open=${open_value}`
          )
          .then((res) => {
            if (res.data.errno == '0') {
              if (res.data.is_open) {
                this.$message({
                  message: '行程已开启',
                  type: 'success',
                })
              } else {
                this.$message({
                  message: '行程已关闭',
                  type: 'warning',
                })
              }
            } else {
              this.$message({
                message: res.data.errmsg,
                type: 'error',
              })
              item.is_open = false
            }
          })
      }
    },
    // 选择方案， 确定需求单的方案
    selectTravelPlan(id) {
      this.$http
        .get(
          `/traver/select_trip_plan_for_user_require?select_trip_plan_id=${id}&require_id=${this.addTravelPlanRequireId}`
        )
        .then((res) => {
          // console.log(res)
          if (res.data.errno == '0') {
            this.$message({
              message: res.data.errmsg,
              type: 'success',
            })
            // 将 current_trip_plan_id 换为选择后的ID
            this.requirement_data.forEach((i) => {
              if (i.id == this.addTravelPlanRequireId) {
                i.current_trip_plan_id = id
              }
            })
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    getRequirementList() {
      this.loading = true
      this.$http
        .get(
          `/traver/get_requirement_form_list?contact=${this.contact}&mobile=${this.mobile}&source=${this.source}&status=${this.status}&start_date=${this.start_date}&dest=${this.dest}&page_size=${this.pagesize}&page_number=${this.pagenum_system}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
            this.requirement_data = res.data.data
            this.page_account = res.data.account
            this.loading = false
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // 打开已添加方案的需求单
    showTravelPlanForRequire(item) {
      this.addTravelPlanRequireId = item.id
      this.dialogVisibleTravelPlan = true
      this.loadingPlan = true
      // 获取当前方案
      this.$http
        .get(
          `/traver/get_require_information?require_id=${this.addTravelPlanRequireId}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
            this.selectRadio = res.data.data.current_trip_plan_id
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
      // 获取方案
      this.$http
        .get(`/traver/get_trip_plan_about_require?require_id=${item.id}`)
        .then((res) => {
          console.log(res)
          // console.log(res.data.data)
          if (res.data.errno == '0') {
            this.oneRequirPlanData = res.data.data
            // console.log(this.oneRequirPlanData[0].plan_detail)
            // let a = JSON.parse(this.oneRequirPlanData[0].plan_detail)
            // console.log(a)
            this.loadingPlan = false
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // 方案列表中添加方案
    addNewPlan() {
      const newpage = this.$router.resolve({
        name: 'creat_travel_plan',
        query: { id: this.addTravelPlanRequireId },
      })
      window.open(newpage.href, '_blank')
    },
    // 直接添加方案
    editorTravelPlanForRequire(item) {
      const newpage = this.$router.resolve({
        name: 'creat_travel_plan',
        query: { id: item.id },
      })
      window.open(newpage.href, '_blank')
    },
    tripStatusChange(item) {
      // console.log(item)
      this.requireModifuId = item.id
    },
    handleCommand(val) {
      // console.log(val)
      // 更改订单状态的接口
      this.$http
        .get(
          `/traver/change_status_of_require?require_id=${this.requireModifuId}&new_status=${val}`
        )
        .then((res) => {
          // console.log(res)
          if (res.data.errno == '0') {
            this.requirement_data.forEach((item) => {
              if (item.id == this.requireModifuId) {
                item.status = val
                item.status_name = this.status_list[val]
              }
            })
            this.$message({
              message: '状态已更新',
              type: 'success',
            })
            // 根据选择的状态，修改需求单
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // 编辑方案
    editorDialogTravelPlan(item) {
      const newpage = this.$router.resolve({
        name: 'modify_travel_plan',
        query: {
          trip_id: item.id,
          require_id: item.require_id,
        },
      })
      window.open(newpage.href, '_blank')
    },
    // 查看完整需求单
    checkRequireTravelPlan(item) {
      this.requireModifuId = item.id
      this.requireDetialVisible = true
      this.require_form = item
      //
      if (this.require_form.require_image_list != '[]') {
        this.requireImageList = new Function(
          'return' + this.require_form.require_image_list
        )()
      }

      if (this.require_form.traffic_booking != '[]') {
        this.trafficBcooking = new Function(
          'return' + this.require_form.traffic_booking
        )()
      }
      console.log(this.require_form.residence_booking_img_list)
      if (this.require_form.residence_booking_img_list != '[]') {
        this.residenceBooking = new Function(
          'return' + this.require_form.residence_booking_img_list
        )()
      }
    },
    requireDetialVisibleClose() {
      // console.log('关闭')
      this.requireModifuId = ''
      this.require_form = {}
      this.requireImageList = []
      this.trafficBcooking = []
      this.residenceBooking = []
    },
    // 修改需求单来源
    changeRequireSource(source_id) {
      console.log(source_id)

      this.$http
        .get(
          `/traver/change_requirement_source?source_id=${source_id}&id=${this.requireModifuId}`
        )
        .then((res) => {
          if (res.data.errno == '0') {
            this.require_form.source_name = res.data.source
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },
    // 打卡修改旅行日期
    openRenewTripDate() {
      this.visableRenewTripDate = true
    },
    // 修改旅行日期
    renewRequireForm() {
      this.$http
        .post('/traver/renew_requirement', this.require_form)
        .then((res) => {
          if (res.data.errno == '0') {
            this.visableRenewTripDate = false
            this.$message({
              type: 'success',
              message: res.data.errmsg,
            })
          } else {
            this.$message({
              type: 'error',
              message: res.data.errmsg,
            })
          }
        })
    },
    // 更新需求及进度
    saveRequirementButton(content, id) {
      let post_item = {
        require_id: id,
        content: content,
      }
      this.$http
        .post('/traver/renew_requirement_content', post_item)
        .then((res) => {
          if (res.data.errno == '0') {
            this.require_form = res.data.require_form
            this.$message({
              type: 'success',
              message: res.data.error,
            })
          } else {
            this.$message({
              type: 'error',
              message: res.data.error,
            })
          }
        })
    },
  },
}
</script>

<style>
.el-dropdown-link {
  cursor: pointer;
}
.status_style_0 {
  background-color: crimson;
  color: #fff;
  font-weight: 900;
  padding: 5px 35px;
  width: 100%;
}
.status_style_1 {
  background-color: green;
  color: #fff;
  font-weight: 900;
  padding: 5px;
}
.status_style_2 {
  background-color: rgb(220, 150, 20);
  color: #fff;
  font-weight: 900;
  padding: 5px;
}
.status_style_3 {
  background-color: red;
  color: #fff;
  font-weight: 900;
  padding: 5px 20px;
}
.status_style_4 {
  background-color: rgb(255, 110, 139);
  color: #fff;
  font-weight: 900;
  padding: 5px 28px;
}
.status_style_5 {
  background-color: rgb(20, 147, 220);
  color: #fff;
  font-weight: 900;
  padding: 5px 20px;
}
.status_style_6 {
  background-color: rgb(167, 220, 20);
  color: #fff;
  font-weight: 900;
  padding: 5px 20px;
}
.status_style_7 {
  background-color: rgb(133, 141, 255);
  color: #fff;
  font-weight: 900;
  padding: 5px;
}
.status_style_8 {
  background-color: rgb(160, 160, 160);
  color: #fff;
  font-weight: 900;
  padding: 5px 35px;
}
</style>
